'use client';

import Image from 'next/image';
import MediaList from './media-list';

const AboutUsMedia = () => {
  return (
    <div className='pb-[38px] pt-10 lg_pb-[366px] lg_pt-[50px]'>
      <h1 className='text-center font-Shango text-[34px] leading-10 lg_text-[46px] lg_leading-[56px]'>MEDIA</h1>
      <Image
        className='mt-10 block w-full lg_hidden'
        src={process.env.NEXT_PUBLIC_BASE_PATH + '/images/about-us/media/banner-m.png'}
        width={1125}
        height={501}
        alt='about us media'
      />

      <Image
        className='mt-10 hidden w-full lg_block'
        src={process.env.NEXT_PUBLIC_BASE_PATH + '/images/about-us/media/banner.png'}
        width={1920}
        height={600}
        alt='about us media'
      />
      <MediaList />
    </div>
  );
};

export default AboutUsMedia;
